import { Check } from "lucide-react";
import { Button } from "lumir-back-office-ui";
import useDisplay from "../../../hooks/useDisplay";
import { useNavigate } from "react-router-dom";

export default function ApplySuccess() {
  const { isMobile } = useDisplay();
  const navigate = useNavigate();

  return (
    <div id="tailwind-root">
      <div
        className="flex flex-col items-center justify-center h-screen text-center mx-[24px]"
        id="tailwind-root"
      >
        <Check className="w-[68px] h-[68px] text-white bg-[#7AD7B5] rounded-full p-2" />

        <p
          className={`typography-semantic-title-1-bold mt-[32px] mb-[16px] ${
            isMobile
              ? "typography-semantic-heading-1-bold"
              : "typography-semantic-title-1-bold"
          }`}
        >
          지원서를 성공적으로 제출했습니다.
        </p>
        <p
          className={`typography-semantic-heading-3-regular ${
            isMobile
              ? "typography-semantic-body-1-reading---regular"
              : "typography-semantic-heading-3-regular"
          }`}
        >
          작성하신 이메일 주소로 곧 지원 확인 메일이 발송될 예정입니다.
        </p>
        <Button
          size={isMobile ? "lg" : "xlg"}
          variant="filled"
          state="primary"
          className="w-[100px] h-[36px] mt-[40px] rounded-md"
          onClick={() => navigate("/")}
        >
          홈으로
        </Button>
      </div>
    </div>
  );
}
